export default [
    {
        path: "/payments/processor/:ptn/payment-method",
        name: "paymentMethod",
        meta: {
            title: "Payment Method",
            authRequired: false,
        },
        component: () => import("../views/payments/new/payment-method.vue"),
    },
    {
        path: "/payments/processor/:ptn",
        name: "newPayment",
        meta: {
            title: "Payments",
            authRequired: false,
        },
        component: () => import("../views/payments/new/new-payment.vue"),
    },
    {
        path: "/payments/processor/card/callback",
        name: "paymentStatusCallback",
        meta: {
            title: "Payments Status Callback",
            authRequired: false,
        },
        component: () => import("../views/payments/new/card-callback.vue"),
    },
    {
        path: "/payments/processor/status/:ptn",
        name: "paymentStatus",
        meta: {
            title: "Payments Status",
            authRequired: false,
        },
        component: () => import("../views/payments/new/payment-status.vue"),
    },
    {
        path: "/payments/history",
        name: "paymentsHistory",
        meta: {
            title: "Payments History",
            authRequired: true,
        },
        component: () => import("../views/payments/history/payments-history.vue"),
    },
    {
        path: "/payments/history/:ptn",
        name: "paymentDetails",
        meta: {
            title: "Payment Details",
            authRequired: true,
        },
        component: () => import("../views/payments/history/payment-details.vue"),
    }
]